import React, { useState, useEffect } from "react";
import "./Modal.css"; 
import { useDispatch, useSelector } from "react-redux";
import { setUserDetails } from "../../../redux/userSlice";
import { apiUrl, otpApiUrl, jsonAuthHeaders } from "../../../config/api.js";
import { devLog } from "../../../config/devLog.js";

const VerifyCompanyModal = ({ isOpen, onClose, message, corporateEmail = "", signupMode = false }) => {
  const { userId, userDetails } = useSelector((state) => state.userReducer);
  const [email, setEmail] = useState(corporateEmail || userDetails.corporate_email);
  const [otp, setOtp] = useState("");
  const [disableEmail, setDisableEmail] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isOpen) {
      setEmail((corporateEmail || userDetails.corporate_email || "").trim());
      setOtp("");
      setDisableEmail(false);
    }
  }, [isOpen, corporateEmail, userDetails.corporate_email]);



  const getOTP = async () =>{
    setDisableEmail(true)
    const response = await fetch(otpApiUrl("getOTP"),{method:"POST", headers: {
      'Content-Type': 'application/json',
    },body:JSON.stringify({email:email})})
    await response.json();
    
    devLog("[verifyModal] getOTP", { ok: response.ok })
    // setLoading(false);
    // setShowOTP(true)
    setTimeout(() => {
      // setResendOtp(true)
    }, 5000);
  }

  const verifyOTP = async () => {
    if (signupMode) {
      const response = await fetch(apiUrl("verifyEmail"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim(), otp: String(otp).trim() }),
      });
      const data = await response.json().catch(() => ({}));
      devLog("[verifyModal] verifyEmail (signup)", { ok: response.ok, message: data?.message });
      if (response.ok) {
        onClose(true);
      }
      return;
    }

    const response = await fetch(apiUrl("verifyOTP"), {
      method: "POST",
      headers: jsonAuthHeaders(),
      body: JSON.stringify({ email: email.trim(), otp: String(otp).trim(), id: userId }),
    });
    await response.json();

    devLog("[verifyModal] verifyOTP", { ok: response.ok });
    const userResponse = await fetch(apiUrl("getUser?" + userId));
    const profileData = await userResponse.json();
    dispatch(
      setUserDetails({
        ...profileData,
        userId: profileData.id,
        name: profileData.first_name + " " + profileData.last_name,
        userEmail: profileData.email,
        company: profileData.companyName ? profileData.companyName : "",
        isVerified: profileData.is_verified,
        corporateEmail: profileData.corporate_email,
      })
    );
    onClose(true);
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="verify-modal-container">
        <div className="modal-header">
          <h2>You are not Verified</h2>
          <button className="modal-top-close" onClick={()=>onClose(false)} aria-label="Close">×</button>
        </div>
        <div className="modal-body">
          <p>
            {message}
          </p>

          <div className="input-group">
            <label>Email Address</label>
            <input placeholder="Corporate Email Address" disabled={disableEmail} onChange={(event)=>{setEmail(event.target.value)}} value={email}></input>
          </div>

          {disableEmail&&<div className="input-group">
            <label>OTP</label>
            <input placeholder="Enter OTP" type="number" onChange={(event)=>{setOtp(event.target.value)}} value={otp}></input>
          </div>}

        </div>
        <div className="modal-footer">
          <button className="modal-close-btn" onClick={()=>{disableEmail?verifyOTP():getOTP()}}>
            Verify Corporate Email
          </button>
          {/* <button className="modal-close-btn" onClick={onClose}> Continue without </button> */}
        </div>
      </div>
    </div>
  );
};

export default VerifyCompanyModal;
